import { StyledProviderLogo } from './ProviderLogo.style';
import {
  BitbucketLogo,
  GithubLogo,
  GitlabLogo,
} from '@/components/illustrations';

const providerNameToLogoMap = {
  github: GithubLogo,
  gitlab: GitlabLogo,
  bitbucket: BitbucketLogo,
  bitbucket_server: BitbucketLogo,
};

const ProviderLogo = ({ provider }) => {
  const ProviderIcon = providerNameToLogoMap[provider.toLowerCase()];
  return (
    <StyledProviderLogo className='avatar-provider-logo'>
      <ProviderIcon />
    </StyledProviderLogo>
  );
};

export default ProviderLogo;
